import React from 'react';
import ellegwhite from '../../images/ellengwhite.jpg';
import { getGcUi } from '../../constants/spanish-gc';

export function AuthorSection({ classname, isPageTemplate, locale = 'en' }) {
  const ui = getGcUi(locale);

  return (
    <div className={`author-section ${classname} ${isPageTemplate ? 'pageTemplateAuthorSection' : ''}`}>
      <div className="author-container">
        <div className="author-content">
          <h2 className="author-title">{ui.authorTitle}</h2>
          <p className="author-description">{ui.authorDescription}</p>
        </div>
        <div className="author-image-container">
          <img src={ellegwhite} alt={ui.authorImageAlt} className="author-image" />
        </div>
      </div>
    </div>
  );
}
